import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Router} from '@angular/router';
import {LabelComponent} from '../label.component';
import {MenuService} from "../../../services/menu.service";
import {ModuleService} from "../../../services/module.service";

@Component({
  selector: 'app-label-add-edit',
  templateUrl: './label-add-edit.component.html',
  styleUrls: ['./label-add-edit.component.scss']
})
export class LabelAddEditComponent {

  labelForm: FormGroup;
  saving = false;
  modules: any[] = [];

  loading = 'Loading...';

  public data: any;

  moduleSelected: number | undefined;

  isSubmitted = false;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef;

  @ViewChild(LabelComponent) permsComponent : LabelComponent;

  constructor(private fb: FormBuilder,
              private menuService: MenuService,
              private moduleService: ModuleService,
              private translate: TranslateService,
              private toastr: ToastrService,
              public activeModal: NgbActiveModal,
              public route: Router
  ) {
    this.labelForm = this.fb.group({
      module: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.minLength(3)]],
      position: null,
      title: 'label',
    });

  }

  ngOnInit() {
    this.labelForm.patchValue(this.data);
    if (this.data){
      this.moduleSelected = this.data.module['@id']
    }
    this.findAllModule();
  }

  get fc(): any {
    return this.labelForm.controls;
  }

  onFormSubmit(): any {
    this.isSubmitted = true;
    if (this.labelForm.valid){
      this.saving = true;
      if (this.data){
        this.labelForm.get('title').setValue('label');
        this.menuService.putLabel(this.data.id, this.labelForm.value).subscribe({
          next: (val: any) => {
            this.toastr.success('Label edit with success !', 'Success');
            //this.menuService.refreshMenus();
            this.activeModal.close();
            //this.labelForm.reset();

          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            if (err && err.violations){
              err.violations.forEach((v) =>
              {
                if (v.propertyPath === 'module'){
                  this.labelForm.get('module')?.setErrors({serverError: v.message});
                }

                if (v.propertyPath === 'name'){
                  this.labelForm.get('name')?.setErrors({serverError: v.message});
                }

                if (v.propertyPath === 'position'){
                  this.labelForm.get('position')?.setErrors({serverError: v.message});
                }

                this.saving = false;
              });
            }else {

              this.toastr.error(err['hydra:title'], 'Error');

              this.saving = false;
            }
          }
        });
      }
      else {
        this.labelForm.get('title').setValue('label');
        this.menuService.postLabel(this.labelForm.value).subscribe({
          next: (val: any) => {
            this.toastr.success('Label create with success !', 'Success');
            // this.activeModal.close();
            this.labelForm.reset({ value: this.labelForm.value, emitEvent: false });
            // this.permissionForm.removeControl('name', { emitEvent: false })
            this.menuService.refreshMenus();

          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            const errors: any[] = err.violations;
            console.log(errors);

            if (err && err.violations){
              errors.forEach((v) =>
              {
                if (v.propertyPath === 'module'){
                  this.labelForm.get('module')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'name'){
                  this.labelForm.get('name')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'position'){
                  this.labelForm.get('position')?.setErrors({serverError: v.message});
                }
                this.saving = false;
              });
            }else {

              this.toastr.error(err['hydra:title'], 'Error');

              this.saving = false;
            }


          }
        });


      }

    }

    // else {
    //   // Si le formulaire est invalide, marquez-le comme non soumis
    //   // pour empêcher les messages de validation de s'afficher immédiatement
    //   this.isSubmitted = false;
    //   this.saving = false;
    // }

  }

  findAllModule(): any{
    this.moduleService.getEnableCollection().subscribe((data: any) => {
          this.modules = data['hydra:member'];
          this.modules = this.modules.map((v) => {
            v.id = v['@id'];
            console.log(v['@id']);
            return v;
          });
        },
        error => console.log(error)
    );
  }


}
